import { Nullable } from '@bybeam/platform-types';

export default function isAccountNumberValid(val: string): Nullable<string> {
  return /^([a-zA-Z0-9]){5,17}$/.test(val) ? undefined : 'Please enter a valid account number';
}
